import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useEffect, useState } from 'react';
import { AsyncStorageProvider, IAsyncSmartStorageProvider } from '../support/AsyncStorageProvider';

class NudgeStorageProvider {
    shownNudges: IAsyncSmartStorageProvider<string[]>;

    static inject = () => [AsyncStorageProvider];
    constructor(private storage: AsyncStorageProvider) {
        this.shownNudges = this.storage.getJSONProvider('shown-nudges');
    }
};

export const useNudgeStorage = ({
    nudgeId,
    autoSave
}: {
    nudgeId?: string;
    autoSave?: boolean;
}): [
    visible: boolean,
    dismiss: () => void
] => {
    const [visible, setVisible] = useState(false);
    const storage = useInstance(NudgeStorageProvider);

    const getShown = async () => {
        return await storage.shownNudges.get() || [];
    };

    const store = async () => {
        if (nudgeId) {
            const shown = await storage.shownNudges.get() || [];
            if (!shown.includes(nudgeId)) {
                await storage.shownNudges.set([...shown, nudgeId]);
            }
        }
    };

    const dismiss = () => {
        setVisible(false);
        store();
    };

    useEffect(() => {
        if (nudgeId) {
            Promise.resolve().then(async () => {
                const shown = await getShown();
                if (!shown.includes(nudgeId)) {
                    setVisible(true);

                    if (autoSave) {
                        store();
                    }
                }
            });
        } else {
            setVisible(true);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return [
        visible,
        dismiss
    ];
};
